import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useLiveGameAccess } from '@/hooks/useLiveGameAccess';
import { canAccessLiveGame, type Role } from '@/types/navigation';

/** Direct /live/:gameKey URLs use the same predicate as the navigation
 * registry: admin/manager always, traders only with a resolved
 * `liveGameAccess` grant. Revoking the grant rerenders this guard and ejects
 * an open live-game page back to the discovery list's home. */
export function LiveGameRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const liveGameAccess = useLiveGameAccess();
  return canAccessLiveGame(role, liveGameAccess) ? <Outlet /> : <Navigate to="/live" replace />;
}
